import clone from 'lodash/clone';
import $ from "jquery";

import Shape from "./shapes/sqftShape";
import MovableImage from "./shapes/movableImage";
import WorkspaceEvents, {clearAllMenusEvents} from "./workspace/workspaceEvents";
import EventManager from "./../store/sqftEventManager";
import RulerOverlay from "./workspace/ruler";
import history from "./workspaceHistory";
import config from "./../store/sqftConfig";
import {
  mmToM,
  sqInchesToSqFoot,
  mm2ToM2,
  getEdgeLength,
  getBacksplashArea, getEdgeArea, getPointField
} from "../../../helpers/sqftHelper";
//todo sqft-react
// import edges from "./controls/edges";
// import Edges from "./controls/edges";
// import TranslatesProvider from "./../../../translatesProvider";
import ShapeHelper, {getEdgeFeatures} from "../../../helpers/shapeHelper";
import store from "../../../../../store";
import {getBacksplashLength} from "../../../helpers/sqftHelper";
import {
  CABINET_BOXES,
  FEATUREGROUP_PART_ID,
  MOVABLE_IMAGE_TYPES,
  POINT_PROPERTY_PART_ID,
  RESOURCE_ATTACHED_TO_TYPE,
  SHAPE_PART_ID,
  SHAPE_TYPE,
  WORKSPACE_RESOURCES
} from "../../../constants";
import ResultImages from "./workspace/resultImages";
import sqftShapeManager from "../store/sqftShapeManager";
import sqftImageManager from "../store/sqftImageManager";
import {deleteCroppedSlabImage, setSqftCroppedSlabImages} from "../../../../../actions/sqftSlabFunctions";
import sqftSlabManager from "../store/sqftSlabManager";
import {updateSQFTCalculations} from "../../../../../actions/sqftFunctions";
import {attachResource, closeSQFTPopup} from "./controls/resourseCanas";
import slabWorkspace from "./slab/slabWorkspace";
import sqftShape from "./shapes/sqftShape";
import {checkShapeForAvailablePartId} from "./shapes/shapeFunctions";
import {getFeatureGroupName} from "../../../../../misc/helpers";
import {getFeatureGroup} from "../../../helpers/sqftHelperUi";
import {getQtCatName} from "../../../helpers/sqftQuotesHelper";
import cabinetWorkspace from "./cabinet/cabinetWorkspace";
import LineCorner from "./shapes/lineHooks/lineCorner";
import TextBoxManager from "./workspace/textBoxManager";
import {
  setShapeIdsWithMissingFeature,
  setShouldShowChangeShapeFeatureMissingMessage,
  setSQFTPopup
} from "../../../../../actions/sqftMenuFunctions";
import {getShapeFeatureId} from "../../../helpers/featureHelper";
import sqftResourcesManager from "../store/sqftResoursesManager";
import {SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE} from "../../../constantsFeature";
import workspaceControllers, {importControllersData} from "../store/workspaceControllers";
import {isSFTCabinetsGroup} from "../../../helpers/sqftNavigationHelper";
import sqftShapeIntersectionsManager from "../store/sqftShapeIntersectionsManager";
import {FeatureObjectDTO} from "../../../dto/FeatureObjectDTO";
import SqftStore from "../store/sqftStore";
import workspaceZoom from "./workspaceZoom";
import sqftEventManager from "./../store/sqftEventManager";
import {getViewportSize} from "../store/canvasHelper";

const workspace = function() {
  //private variables
  var canvas = null;
  var self = this;
  var state = {
    mouseDown: false,
    mouseDownPosition: null,
    allowDragEdge: false,
    allowDragBumpoutEdge: false,
    allowDragMiteredEdge: false,
    lineHighlight: true,
    loading: false
  };
  var objIds = 0;
  var pos = { //workspace top-left corner position
    x: 0,
    y: 0
  };
  var shapes = [];
  var nodes = {
    appBody : $('body'),
    tools: {
      designDefault: $('#design-default')
    }
  };
  //public variables
  this.name = 'workspace';
  this.isInitialized = false;
  this.isEdgeFeatureError = false;
  this.dataHasBeenImported = false;
  this.isLastParent = true; // used to get {x: 0, y:0} position
  this.miteredController = null;
  this.underlaymentController = null;
  this.resultImages = new ResultImages(this);
  this.textBoxManager = new TextBoxManager();
  this[WORKSPACE_RESOURCES.spacers] = [];
  this[WORKSPACE_RESOURCES.handles] = [];
  this[WORKSPACE_RESOURCES.hinge] = [];
  this[WORKSPACE_RESOURCES.walls] = [];
  this[WORKSPACE_RESOURCES.shapeColors] = [];
  this[WORKSPACE_RESOURCES.waterfall] = [];
  this[WORKSPACE_RESOURCES.removedFeatures] = [];
  this[WORKSPACE_RESOURCES.snappedShapeGroups] = [];
  this[WORKSPACE_RESOURCES.selectedShapes] = [];
  this[WORKSPACE_RESOURCES.images3d] = [];
  this[WORKSPACE_RESOURCES.images3dAutoSaved] = [];

  //private functions
  function setCanvas(value) {
    canvas = value;
  }
  var moveWorkspace = function(mousePos) {
    var xDiff = mousePos.x - state.mouseDownPosition.x;
    var yDiff = mousePos.y - state.mouseDownPosition.y;

    pos.x -= xDiff;
    state.mouseDownPosition.x = mousePos.x;

    pos.y -= yDiff;
    state.mouseDownPosition.y = mousePos.y;

    slabWorkspace.setPos({
        x: slabWorkspace.pos.x += xDiff,
        y: slabWorkspace.pos.y += yDiff
      }
    )
  };
  //private events
  var onMouseDown = function(mousePos, e) {
    void e;
    //debugger // eslint-disable-line no-debugger
    if (!window.lineInputFocused) {
      EventManager.stealCursor(true, true);
      state.mouseDown = true;
      state.mouseDownPosition = mousePos;
      EventManager.setCursor('grabbing', self, false);
      //debugger // eslint-disable-line no-debugger
      return true;
    }
  };

  function onMouseUp(mousePos, e) {
    state.mouseDown = false;
    state.mouseDownPosition = null;
    // var selectedMenu = $('.pallet-tool-icon-selected');
    // if (!(selectedMenu && selectedMenu.attr('data-action') === "rotate-left" || selectedMenu.attr('data-action') === "delete")) {
    //   EventManager.resetCursor(self);
      // config.highlight.type = '';
      // $('.steps-scope-config-button').removeClass('active');
    // }
    //todo this takes too much time to update
    sqftShapeIntersectionsManager.updateShapesIntersections();
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);

    return onMouseMove(mousePos, e);
  }

  function onMouseMove(mousePos, e) {
    //debugger // eslint-disable-line no-debugger
    if (e.terminate) {
      return false;
    }
    if (state.mouseDown) {
      moveWorkspace(mousePos);
      // EventManager.setCursor('grabbing', self);
    } else {
      EventManager.resetCursor(self);
    }

    return true;
  }

  //public functions
  this.getObjIds = function() {
    return objIds;
  };
  this.setObjIds = (value) => {
    objIds  = value
  };
  this.stealCursor = function(who) {
    EventManager.resetCursor(self);
    for(var i = 0; i < shapes.length; i++) {
      shapes[i].stealCursor(who);
    }
  };
  this.setAllowEdges = function(allow) {
    state.allowDragEdge = allow;
  };
  this.getAllowEdges = function() {
    return state.allowDragEdge
  };
  this.setAllowBumpoutEdges = function(allow) {
    state.allowDragBumpoutEdge = allow;
  };
  this.getAllowBumpoutEdges = function() {
    return state.allowDragBumpoutEdge
  };
  this.setAllowMiteredEdges = function(allow) {
    state.allowDragMiteredEdge = allow;
  };
  this.getAllowMiteredEdges = function() {
    return state.allowDragMiteredEdge
  };
  this.setAllowLineHighlight = function(allow) {
    state.lineHighlight = allow;
  };
  this.getAllowLineHighlight = function() {
    return state.lineHighlight
  };
  this.getCenter = function() {
    return {
      x: pos.x * -1,
      y: pos.y * -1
    }
  };
  this.setCenter = function(canvasWidth = window.innerWidth, canvasHeight = window.innerHeight) {
    pos.x = parseInt(0 - (canvasWidth / 2));
    pos.y = parseInt(0 - (canvasHeight / 2));
    //console.log("pos.x!", pos.x)
    //console.log("pos.y!", pos.y)
  };
  this.getVisibleCenter = function() {
    const { canvasWidth, canvasHeight } = getViewportSize(sqftEventManager.canvas);
    return {
      x: (pos.x + (canvasWidth / 2)) / config.scale,
      y: (pos.y + (canvasHeight / 2)) / config.scale
    };
  };
  this.getAllShapePoints = () => {
    let allShapePoints = [];
    for (const shape of shapes) {
      //allShapePoints.push(...shape.getPointFieldArray());
      const shapeCenter = shape.getCenter();
      const shapeCenterPointField  = getPointField(shapeCenter, shape);
      void shapeCenterPointField;
      allShapePoints.push(shapeCenter);
    }
    return allShapePoints
  }
  this.getShapesCenterPoint = () => {
    const allShapePoints = this.getAllShapePoints();
    return ShapeHelper.getCenterPoint(allShapePoints);
  }
  this.getCanvas = function() {
    if (!canvas) {
      return sqftEventManager.getOffScreenCanvas();
    }
    return canvas[0];
  };
  this.get$Canvas = function() {
    return canvas;
  };
  this.getOffset = function() {
    return self.getCenter();
  };
  this.setPosition = (newPos) => {
    slabWorkspace.setPos({
        x: slabWorkspace.pos.x += pos.x - newPos.x,
        y: slabWorkspace.pos.y += pos.y - newPos.y
      }
    )
    //console.log("newPos", newPos);
    pos = clone(newPos);
  };
  this.getPosition = function() {
    return pos;
  };
  this.getScale = function() {
    return config.scale;
  };
  this.getState = function() {
    return state;
  };
  this.isEmpty = () => {
    return this.getShapes().length === 0
  }
  this.getHoverShape = function() {
    for (var i = 0; i < shapes.length; i++) {
      var shape = shapes[i];
      if (shape.isHovering()) {
        return shape;
      }
    }
  };
  this.getHoveredSqftShape = (shouldUpdateHovering = false) => {
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.isHovering(shouldUpdateHovering) && shape instanceof sqftShape) {
        return shape;
      }
    }
  };
  this.getMovingShape = () => {
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.getState().mouseDown && (shape instanceof sqftShape || shape instanceof MovableImage)) {
        return shape;
      }
    }
  };
  this.getHoverBumpout = function() {
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      let lines = shape.getLines ? shape.getLines() : null;
      if (lines) {
        for (let n = 0; n < lines.length; n++) {
          if (lines[n].isWithBumpout && lines[n].isWithBumpout() && lines[n].bumpoutOverlay.isHoveringRect()) {
            return lines[n];
          }
        }
      }
    }
  };
  this.getLineWithMovingBumpout = function() {
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      let lines = shape.getLines ? shape.getLines() : null;
      if (lines) {
        for (let n = 0; n < lines.length; n++) {
          if (lines[n].isWithBumpout && lines[n].isWithBumpout() && lines[n].bumpoutOverlay.isBumpoutPointMoving()) {
            return lines[n];
          }
        }
      }
    }
  };
  this.getHoverPoint = function() {
    for(var i = 0; i < shapes.length; i++) {
      if(typeof (shapes[i].getHoverPoint) === 'function') {
        var point = shapes[i].getHoverPoint();
        if(point) {
          return point;
        }
      }
    }
  };
  this.getHoverMiteredPoint = function() {
    for(let i = 0; i < shapes.length; i++) {
      if(typeof (shapes[i].getHoverPoint) === 'function' && shapes[i].isWithMitered()) {
        let point = shapes[i].getHoverMiteredPoint();
        if(point) {
          return point;
        }
      }
    }
  };
  this.getHoveredLine = function() {
    for (let i = 0; i < shapes.length; i++) {
      if (typeof (shapes[i].getHoverSegment) === 'function') {
        let hoveredLine = shapes[i].getHoverSegment();
        if (hoveredLine) {
          return hoveredLine;
        }
      }
    }
  };
  this.getHoveredLines = (skipShapeIds = []) => {
    const iterateShapes =  shapes.filter(shp => !skipShapeIds.includes(shp.id));
    const hoveredLines = [];
    for (let i = 0; i < iterateShapes.length; i++) {
      if (typeof (iterateShapes[i].getHoverSegment) === 'function') {
        let hoveredLine = iterateShapes[i].getHoverSegmentV2();
        if (hoveredLine) {
          hoveredLines.push(hoveredLine);
        }
      }
    }
    return hoveredLines
  };
  this.getHoveredLineCorner = function() {
    for (let i = 0; i < shapes.length; i++) {
      if (typeof (shapes[i].getHoverSegmentOutlineCorner) === 'function') {
        let hoveredLine = shapes[i].getHoverSegmentOutlineCorner();
        if (hoveredLine) {
          return hoveredLine;
        }
      }
    }
  };
  this.getShapesWithoutAttachedResources = (isWithoutHidden = false) => {
    if (isWithoutHidden) {
      return shapes.filter(shape => !shape.isHidden);
    }
    return shapes
  }

  this.getShapes = (isWithoutHidden = false) => {
    const state = store.getState();
    const attachedToLineResources = state.sqftResourceState.attachedToLine;

    if (isWithoutHidden) {
      return shapes.concat(attachedToLineResources).filter(shape => !shape.isHidden);
    }

    return shapes.concat(attachedToLineResources);
  };
  this.getShapeIds = function() {
    const shapes = this.getShapesWithoutAttachedResources();

    return shapes.map(shape => shape.id);
  };
  this.getShapesByIds = (ids) => {
    const shapes = this.getShapes();

    return shapes.filter(shape => ids.includes(shape.id));
  };
  this.getShapesBySlabModeCoreParentId = (ids) => {
    const shapes = this.getShapes();

    return shapes.filter(shape => ids.includes(shape.slabModeCoreParentId));
  };
  this.getShapesByPartId = (partId) => {
    const shapes = this.getShapes();

    return shapes.filter(shape => shape.partId === partId);
  };
  this.getShapesByFeatureId = (featureId) => {
    const shapes = this.getShapes();

    return shapes.filter(shape => shape.featureId === featureId || shape.backsplashFeatureId === featureId);
  };
  this.getShapesByParentFeatureId = (featureId) => {
    const shapes = this.getShapes();

    return shapes.filter(shape => shape.relatedParentFeatureId === featureId);
  };

  this.clearWorkspace = () => {
    this.removeAllShapes();
    objIds = 0;
    shapes = [];
    this.textBoxManager.removeAllTextBoxes();
    sqftImageManager.removeAllSlabImages();
    sqftSlabManager.removeAllSlabBacksplashes();
    sqftResourcesManager.deleteAllResources();
    sqftResourcesManager.deleteAllMiteredSections();
    sqftSlabManager.deleteShapeOffset();
    SqftStore.seamHistory = [];
  }

  this.import = (importData) => {
    //todo on cancel click line state.withBumout somehow turns to false
    this.clearWorkspace();
    clearAllMenusEvents();
    SqftStore.edgeFeatures = [];

    console.log("importData to SQFT", importData);
    this.dataHasBeenImported = true;
    objIds = importData.objIds || 0;
    const shapesData = importData.countertops || importData.shapes; // QCDES-1639 "shapes" for old compatibility
    state.loading = true;
    let _images = [];
    let _attachedResources = [];
    if (shapesData) {
      let shape;
      for (let i = shapesData.length - 1; i >= 0; i--) {
        let value = shapesData[i];
        if (value.lines) {
          shape = this.importShape(value);
        } else if (Object.keys(RESOURCE_ATTACHED_TO_TYPE).some((key) => key === value.type)) {
          _attachedResources.push(value);
        } else if (value.image && value.type !== MOVABLE_IMAGE_TYPES.slabImage) {
          _images.push(value);
        }
      }
      if (shape && canvas) {
        /**
         * Update position after canvas width and height is set
         */
        setTimeout(() => {
          const shapeCenter = workspaceZoom.getShapeCenter(shape, false, 0);
          this.setPosition(shapeCenter);
        })

      }
    }
    //1) Import additional shapes that are visible only in the slab mode
    sqftSlabManager.importSlabBacksplashes(importData.slabAdditionalShapesList || []);

    //2) Add attached resources
    //We will skip adding mitered as it was already added when the line was initiated
    for (const attachedResource of _attachedResources) {
      let lines = this.getLinesAndLineCorners();
      lines.forEach((line) => {
        if (attachedResource.attachedToId === line.id) {
          line.isDisabledInPopup = attachedResource.isDisabledInPopup;
          attachResource(line.isLine ? line : null,
            line instanceof LineCorner ? line : null,
            attachedResource.type,
            attachedResource.featureId,
            attachedResource.partId,
            attachedResource.name,
            attachedResource.height ? attachedResource.height : attachedResource.featureId, //support for old quotes, can be removed in future
            attachedResource.id,
            attachedResource.qtCatName
          );
        } else if (attachedResource.attachedTo === line.id) {
          //old version support
          attachResource(line.isLine ? line : null,
            line instanceof LineCorner ? line : null,
            attachedResource.type,
            attachedResource.featureId,
            attachedResource.partId,
            attachedResource.image.name,
            attachedResource.height ? attachedResource.height : attachedResource.featureId,  //support for old quotes, can be removed in future
            attachedResource.id
          );
        }
      });
    }

    //3) Add movable images
    for (let i = 0; i < _images.length; i++) {
      this.importImage(_images[i]);

      // if (data.attachedTo) {
      //   switch(value.type) {
      //     case "backsplash":
      //     case "wall":
      //       if (value.part === 'lineCorner') {
      //         data.attachedTo.addBacksplashToCornerLine(value.image.name, value.type, value.image.id);
      //       } else {
      //         data.attachedTo.addBacksplashToLine(value.image.name, value.type, value.image.id);
      //       }
      //       break;
      //     case "edge":
      //       if (value.part === 'lineCorner') {
      //         data.attachedTo.lineCorner.addEdgeToCornerLine(value.image.name, value.image.id);
      //       } else {
      //         data.attachedTo.addEdgeToLine(value.image.name, value.image.id);
      //       }
      //       break;
      //   }
      // }
    }

    this.textBoxManager.setImportedTextBoxes(importData.textBoxes);
    sqftImageManager.importSlabImages(importData.slabImages || []);

    const {sqftMenuState} = store.getState();
    const {isShapeFeatureMissing} = sqftMenuState;
    if (isShapeFeatureMissing) {
      this.showChangeShapeColorsMessage();
    }
    importControllersData(importData.controllers);

    history.rememberShapes();
    state.loading = false;

    const wasCabinetShapesAdded = importData.countertops && importData.countertops.some(shape => CABINET_BOXES.includes(shape.partId))
    if (isSFTCabinetsGroup() || wasCabinetShapesAdded) {
      cabinetWorkspace.initCabinetEvents();
    }

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };
  this.importImage  = (imageData) => {
    const image = this.generateImage(imageData.image);
    // compatibility (can be removed in future)
    const depth = !imageData.size.depth && imageData.size.thickness ? imageData.size.height : imageData.size.depth
    const importedMovableImage = this.addImage(
      image,
      imageData.size.width,
      depth,
      imageData.attachedTo,
      imageData.attachedTo ? imageData.attachedTo.getParent() : null,
      imageData.type,
      imageData.subtype,
      null,
      null,
      imageData.part,
      imageData.id,
      imageData.priority,
      imageData.featureId
    );
    // _img.pos.x = imageData.pos.x;
    // _img.pos.y = imageData.pos.y;
    importedMovableImage.importData(imageData); //import object here

    return importedMovableImage
  }
  this.generateImage = (imageData) => {
    let image = new Image();
    for (const imageProperty in imageData) {
      if (imageData.hasOwnProperty(imageProperty)) {
        image[imageProperty] = imageData[imageProperty];
      }
    }
    return image
  };
  this.importShape = (shapeData) => {
    let shape = new Shape();
    shape.import(shapeData);
    shapes.push(shape);

    return shape
  }
  this.showChangeShapeColorsMessage = () => {
    const {sqftMenuState} = store.getState();
    const {isShapeFeatureMissing, shapeIdsWithMissingFeature} = sqftMenuState;
    if (isShapeFeatureMissing) {
      store.dispatch(setSQFTPopup(
        {
          title: this.intl.formatMessage({id: "sqft.popup.title.systemMessage"}),
          content: this.intl.formatMessage({id: "sqft.popup.system.shapeFeaturesWasFailed"}),
          isOpened: true,
          confirmCallback: () => {
            this.removeShapeWithIds(shapeIdsWithMissingFeature);
            store.dispatch(setShapeIdsWithMissingFeature([]));
            store.dispatch(setShouldShowChangeShapeFeatureMissingMessage(false));
            closeSQFTPopup();
          },
          confirmText: this.intl.formatMessage({id: "sqft.popup.button.yes"}),
          cancelCallback: () => {
            store.dispatch(setShapeIdsWithMissingFeature([]));
            store.dispatch(setShouldShowChangeShapeFeatureMissingMessage(false));
            closeSQFTPopup();
          },
          cancelText: this.intl.formatMessage({id: "sqft.popup.button.no"}),
        }
      ));
    }
  }
  this.getPointProperty = (property) => {
    let arcLengths = [];
    let partId = POINT_PROPERTY_PART_ID[property];
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.getLines) {
        let lines = shape.getLines();
        for (let n = 0; n < lines.length; n++) {
          let point = lines[n].from;
          if (point[property] > 0) {
            arcLengths.push({
              id: point.id,
              value: point[property],
              featureId: point.featureId,
              qtCatName: getQtCatName(),
              partId: partId,
              quantity: 1,
            });
          }
        }
      }
    }
    return arcLengths;
  };
  this.getSink = function() {
    var sinks = [];
    for(var i = 0; i < shapes.length; i++) {
      var shape = shapes[i];
      if(shape.getAttachedTo && !shape.getAttachedTo()) { //sink not edging
        var img = shape.getImage();
        var sinkId = img.dataset.id;
        if(sinkId) {
          var bExists = false;
          for(var n = 0; n < sinks.length; n++) {
            if(sinks[n].id === sinkId) {
              sinks[n].qty++;
              bExists = true;
              break;
            }
          }
          if(!bExists) {
            sinks.push({
              sink: img,
              name: img.dataset.name,
              id: sinkId,
              qty: 1
            });
          }
        }
      }
    }
    return sinks;
  };
  /**
   * get all bumpouts
   */
  this.getBumpouts = () => {
    return shapes
      .filter(shape => shape.getLines)
      .flatMap(shape =>
        shape.getLines()
          .filter(line => line.isWithBumpout && line.isWithBumpout())
          .map(line => {
            const area = config.measureUnit === "Metric"
              ? line.bumpoutOverlay.getBumpoutTotalArea().millimeters
              : line.bumpoutOverlay.getBumpoutTotalArea().inches;
            const featureObjectDTO = new FeatureObjectDTO(line.bumpoutOverlay.id, FEATUREGROUP_PART_ID.specialty_cut_and_designs, line.bumpoutOverlay.featureId);
            featureObjectDTO.addBumpoutArea(area)

            return featureObjectDTO;
          })
      );
  };

  this.getLines = () => {
    let allLines = [];
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.getLines && shape instanceof sqftShape) {
        allLines = allLines.concat(shape.getLines());
      }
    }

    return allLines;
  };

  this.getLineCorners = () => {
    let allLineCorners = [];
    for (let i = 0; i < shapes.length; i++) {
      let shape = shapes[i];
      if (shape.getLineCorners) {
        allLineCorners = allLineCorners.concat(shape.getLineCorners());
      }
    }

    return allLineCorners;
  };

  this.getLinesAndLineCorners = () => {
    return this.getLines().concat(this.getLineCorners())
  }

  this.getLineById = (id) => {
    let allLines = this.getLines();

    return allLines.find((line) => line.id === id);
  };

  this.getLineCornerById = (id) => {
    let allLines = this.getLines();
    const line = allLines.find((line) => line.lineCorner !== undefined && line.lineCorner.id === id);

    if (line !== undefined) {
      return line.lineCorner
    }
  };

  this.getLineOrCornerLineById = (id) => {
    let lineSegment = this.getLineById(id)
    if (lineSegment) {
      return lineSegment
    }
    return this.getLineCornerById(id)
  };

  this.getMiteredSections = function() {
    // let mitered = [];
    // for(let i = 0; i < shapes.length; i++) {
    //   let shape = shapes[i];
    //   if(shape.getLines) {
    //     let lines = shape.getLines();
    //     for(let n = 0; n < lines.length; n++) {
    //       if(lines[n].isWithMitered()) {
    //         mitered.push(lines[n].miteredOverlay);
    //       }
    //     }
    //   }
    // }
    const reduxState = store.getState();

    return reduxState.sqftMiteredState.miteredSections;
  };

  /**
   * @deprecated use features from redux store
   */
  this.getShapeType = (type) => {
    let addedEdges = [];
    let edgeName;
    let isImageShapeType;
    let isLabelShapeType;
    let backsplashLength = 0;
    let area = 0;
    let length = 0;
    let realLength = 0;
    let lineLength = 0;
    let unit = null;
    const storedShapes = this.getShapes().filter(shp => {
      return !SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE.includes(shp.partId)
    });
    const state = store.getState();
    const fabricatorData = state.fabricatorState;

    for (let i = 0; i < storedShapes.length; i++) {
      const shape = storedShapes[i];
      isImageShapeType = shape.type && shape.type.includes(type);
      isLabelShapeType = shape instanceof sqftShape && shape.partId.includes(type);
      if (isImageShapeType && !isLabelShapeType) {
        const attachedTo = shape.attachedToId
          ? this.getLineOrCornerLineById(shape.attachedToId)
          : shape.historyProps
            ? shape.historyProps.attachedTo
            : null; //old quotes support can be removed in future

        let featureId = +shape.featureId;
        length = 0;
        area = 0;

        if (type === "backsplash") {
          length = attachedTo ? getBacksplashArea(attachedTo.getBacksplashHeight(), attachedTo) : 0;
          backsplashLength = attachedTo ? getBacksplashLength(attachedTo) : 0;
        } else if (type === "wall") {
          length = realLength = getEdgeLength(attachedTo);
        } else {
          const navItems = getEdgeFeatures();
          let edge = navItems.find(edge => edge.part.dbFeature.id === featureId);
          if (edge && edge.part) {
            let edgeFeature = edge.part.dbFeature;
            unit = edgeFeature ? edgeFeature.unit : null;
          }
          // count only one length for "each" units
          length = (unit ? unit.toLowerCase() : null) === "each" ? 1 : getEdgeLength(attachedTo);
          realLength = getEdgeLength(attachedTo);
          lineLength = config.measureUnit === "Imperial" ? attachedTo.getLineLength() : attachedTo.getLineLengthMm();
          area = getEdgeArea(attachedTo, lineLength, featureId);
        }
        // export all edges (combine them after adding to cart from popup)

        // for (let n = 0; n < addedEdges.length; n++) {
        //   if(addedEdges[n].id === edgeId) {
        //     addedEdges[n].length += length;
        //     addedEdges[n].realLength += realLength;
        //     addedEdges[n].area += area;
        //     addedEdges[n].pieces.push(backsplashLength);
        //     addedEdges[n].segments += 1;
        //     //bExists = true;
        //     break;
        //   }
        // }
        //if(!bExists) {
          //todo sqft-react translate
          //edgeName = TranslatesProvider.translate('transDoc.customDisplayName_FR.' + img.dataset.sharedFeatureName, img.dataset.name);
          edgeName = shape.name; //intl.formatMessage({id: edgeFeature.dbFeature.sharedFeatureName}); //img.dataset.name;

          addedEdges.push({
            parentId: attachedTo ? attachedTo.getParent().id : null,
            partId: attachedTo ? attachedTo.getParent().partId : null,
            fromWizardGroupId: attachedTo ? attachedTo.getParent().fromWizardGroupId : "",
            edge: featureId,//img,
            name: edgeName,
            id: featureId,
            segments: 1,
            pieces: [backsplashLength],
            length,
            realLength,
            unit,
            area
          });
        //}
      } else if (isLabelShapeType && shape.getTotalInches) {
        area = config.measureUnit === "Imperial" ? sqInchesToSqFoot(shape.getTotalInches()) : mm2ToM2(shape.getTotalMillimeters());
        length = config.measureUnit === "Imperial" ? sqInchesToSqFoot(shape.getTotalInches()) : mm2ToM2(shape.getTotalMillimeters());
        let featureGroup = getFeatureGroup(shape.partId);
        if (featureGroup && featureGroup.part) {
          let featureGroupName = getFeatureGroupName(featureGroup.part, this.intl, fabricatorData);
          addedEdges.push({
            partId: shape.partId,
            fromWizardGroupId: shape.fromWizardGroupId,
            //edge: img,
            name: featureGroupName,
            //id: edgeId,
            segments: 1,
            length,
            area
          });
        }
      }
    }
    if (type === "edge") {
      for (let n = 0; n < addedEdges.length; n++) {
        addedEdges[n].length = config.measureUnit === "Imperial" ? addedEdges[n].length : mmToM(addedEdges[n].length);
      }
    }

    return addedEdges;
  };

  this.addImage = function(
    image,
    width,
    depth,
    attachedTo,
    hoverShape,
    type,
    subType, // appliance type
    historyCallBack,
    historyPosition,
    part = null,
    objId = null,
    priority = null,
    featureId = null,
    hide = false,
    params = {
      canSnap: true,
      isResizable: true
    },
  ) {
    let vc = self.getVisibleCenter(),
      newImage = new MovableImage(objId ? objId : ++objIds, priority, subType, params);

    newImage.onInit = self.onShapeReady;
    newImage.attachedToShape = hoverShape;
    newImage.type = type;
    newImage.part = part;
    newImage.featureId = featureId;
    newImage.init(
      historyPosition || {x: vc.x - (width / 2), y: vc.y - (depth / 2)},
      image,
      { width: width, depth: depth},
      attachedTo,
      hide
    );
    attachedTo && (attachedTo.attachedShape = newImage);
    newImage.historyProps = {
      image: image,
      width: width,
      depth: depth,
      attachedTo: attachedTo,
      attachedToParentId: attachedTo
        ? attachedTo.getParent ? attachedTo.getParent().id : null
        : null,
      hoverShape: hoverShape,
      type: type,
      subType: subType,
      part: part,
      historyCallBack: historyCallBack,
      featureId: featureId
    };
    shapes.unshift(newImage);

    return newImage;
  };

  this.getAllAttachedResources = () => {
    const state = store.getState();

    return state.sqftResourceState.attachedToLine;
  };
  this.getAttachedTo = function(attachedTo) {
    const state = store.getState();

    return state.sqftResourceState.attachedToLine.find(attachedToLine => attachedToLine.attachedToId === attachedTo.id)
  };
  this.getAttachedToLineResource = (type) => {
    const reduxState = store.getState();
    return reduxState.sqftResourceState.attachedToLine.filter(attachedToLine => {
      return attachedToLine.type === type
    });
  };
  this.getImagesAttachedTo = function(attachedTo) {
    for (var i = 0; i < shapes.length; i++) {
      if(shapes[i].getAttachedTo) {
        if(shapes[i].getAttachedTo() === attachedTo) {
          return shapes[i];
        }
      }
    }
  };
  this.onShapeReady = function() {

  };

  this.addShape = function(segments, shapeType, historyPosition, partId, fromLayout = null, shapeParams = {}) {
    const realPartId = checkShapeForAvailablePartId(partId);
    let vc = self.getVisibleCenter(),
      mm = sqftShapeManager.getMinMax(segments),
      shapeId = ++objIds,
      newShape = new Shape(shapeId, shapes.length, shapeType, realPartId, fromLayout, shapeParams),
      openedMobileButton = $('.pallet-wrapper--opened');

    newShape.setQtCatName(getQtCatName())
    newShape.onHover = self.onShapeHover;
    newShape.onInit = self.onShapeReady;
    newShape.init(
      historyPosition || {x: vc.x - (mm.width/2), y: vc.y - (mm.height/2)}, //position
      segments
    );
    shapes.unshift(newShape);
    !nodes.appBody.hasClass('step--shapes--selected') && nodes.appBody.addClass('step--shapes--selected');
    (openedMobileButton.length > 0) && openedMobileButton.removeClass('pallet-wrapper--opened');
    if (nodes.appBody.hasClass('tutorial--enabled')) {
      this.tutorialShape = newShape;
    }
    newShape.setFeatureId(getShapeFeatureId(realPartId));
    newShape.setOriginalPointsCoords(newShape.getPointsCoords());

    return shapeId
  };

  this.removeTutorialShape = function () {
    this.tutorialShape && this.removeShape(this.tutorialShape);
  };

  this.removeShapeWithIds = (shapeIds) => {
    for (let i = shapeIds.length - 1; i >= 0; i--) {
      this.removeShapeById(shapeIds[i]);
    }
  }

  this.removeShapeById = function(id) {
    for (let i = shapes.length - 1; i >= 0; i--) {
      if (shapes[i] && shapes[i].id === id) {
        if (shapes[i] instanceof MovableImage && shapes[i].type === MOVABLE_IMAGE_TYPES.slabImage) {
          this.removeSlabImage(shapes[i]);
        } else {
          this.removeShape(shapes[i])
        }
      }
    }
  };

  this.removeSlabImage = (movableImage) => {
    const reduxState = store.getState();
    const croppedSlabImages = reduxState.sqftSlabState.croppedSlabImages || [];

    if (!Array.isArray(croppedSlabImages)) {
      console.error('croppedSlabImages is not a valid array');
      return;
    }

    store.dispatch(deleteCroppedSlabImage(movableImage.id));
    this.removeShape(movableImage);

    if (croppedSlabImages.length === 0) {
      slabWorkspace.deregisterEvents();
    }
  };

  this.getShapeById = (id) => {
    const combinedShapes = this.getShapes();
    for (let i = combinedShapes.length - 1; i >= 0; i--) {
      if (combinedShapes[i].id === id) {
        return combinedShapes[i]
      }
    }

    return null
  };

  this.removeShape = (shape) => {
    const shapesCopy = [...shapes];

    // Iterate a copy of the shapes array from end to beginning
    for (let i = shapesCopy.length - 1; i >= 0; i--) {
      const currentShape = shapesCopy[i];

      if (currentShape && currentShape.id === shape.id) {

        if (currentShape.shapeType in SHAPE_TYPE) {
          currentShape.getLines().forEach((line) => {
            if (line.overlay) {
              line.overlay.destroy();
            }
            line.deleteAttachedItem ? line.deleteAttachedItem() : void null;
            line.to.removeAttachedItem ? line.to.removeAttachedItem() : void null;
          });
        }

        if (currentShape) {
          currentShape.destroy();

          // Find current shape index in the original array and delete it
          const originalIndex = shapes.indexOf(currentShape);
          if (originalIndex !== -1) {
            shapes.splice(originalIndex, 1);
          }
        }
      }
    }

    if (shape.removeShapePieces) {
      shape.removeShapePieces();
    }

    slabWorkspace.slabAdditionalShapes.removeShapeFromList(shape);

    const reduxState = store.getState();
    const updateCalculations = reduxState.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  };


  this.updateRemovedFeatures = (shape) => {
    if (shape.partId === SHAPE_PART_ID.slabPlaceHolder
      || shape.type === MOVABLE_IMAGE_TYPES.slabImage
    ) {
      workspaceControllers.removedFeatures.addResource(shape.id);
    }
  };

  this.removeAllShapes = function() {
    for (let i = shapes.length - 1; i >= 0; i--) {
      if (shapes[i]) {
        self.removeShape(shapes[i])
      }
    }
    // todo sqft react: lineLength are not equal when going back to sqft
    //_.isEqual(sqftEventManager.activeEvents["render"][11].sender, shapes[i].getLines()[3].overlay)
  };
  this.removeFeatureBySQFTId = (sqftId) => {
    //console.log("sqftId to remove", sqftId);
    this.removeShapeById(sqftId);
    sqftResourcesManager.deleteAttachedItemById(sqftId);

    // sqftImageManager.removeAllSlabImages();
    // sqftSlabManager.removeAllSlabBacksplashes();
    // sqftResourcesManager.deleteAllResources();
    // sqftResourcesManager.deleteAllMiteredSections();
    // sqftSlabManager.deleteShapeOffset();
  };
  this.removeAllBumpouts = function() {
    for (let i = shapes.length - 1; i >= 0; i--) {
      if (shapes[i] && shapes[i].removeBumpouts) {
        shapes[i].removeBumpouts()
      }
    }
  };
  this.removeAllSlabImages = () => {
    for (let i = shapes.length - 1; i >= 0; i--) {
      if (shapes[i] instanceof MovableImage && shapes[i].type === 'slabImage') {
        self.removeShape(shapes[i].destroy())
      }
    }
    store.dispatch(setSqftCroppedSlabImages([]));
  };

  this.onShapeHover = function() {
  };
  this.setIntl = (intl) => {
    this.intl = intl
  };

  this.init = ($canvas = null, intl = null) => {
    //set global configuration
    this.isInitialized = true;
    this.name = config.workspace.name;
    setCanvas($canvas);
    if (intl) {
      this.intl = intl
    }
    //initialize workspace canvas such that 0x 0y is in the center
    const { canvasWidth, canvasHeight } = getViewportSize(sqftEventManager.canvas);
    pos.x = parseInt(0 - (canvasWidth / 2));
    pos.y = parseInt(0 - (canvasHeight / 2));
    //connect events
    EventManager.init(canvas[0]);
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      self,
      EventManager.priorities.WORKSPACE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      self,
      EventManager.priorities.WORKSPACE
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      onMouseUp,
      self,
      EventManager.priorities.WORKSPACE
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      self.render,
      self,
      EventManager.priorities.WORKSPACE
    );

    WorkspaceEvents.init();
    RulerOverlay.init();
    if (isSFTCabinetsGroup()) {
      cabinetWorkspace.initCabinetEvents();
    }
  };

  this.render = (ctx) => {
    this.renderGrid(ctx);
    Object.values(workspaceControllers).forEach(workspaceController => {
      if (workspaceController.render) {
        workspaceController.render();
      }
    });
  };

  this.renderGrid = (ctx) => {
    let i;
    var scale = config.scale;
    var gridSize = config.workspace.gridSize * scale;
    var start = {
      x: ((pos.x % gridSize) * -1),
      y: ((pos.y % gridSize) * -1)
    };
    var canvasWidth = canvas[0].width;
    var canvasHeight = canvas[0].height;
    var center = self.getCenter();
    var scaledGrid = gridSize / Math.round(config.workspace.gridSize / config.workspace.getScaledGridSize());
    //render grid background
    ctx.lineWidth = 1;
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    // rendering cells
    if(scale > 1) {
      ctx.beginPath();
      for(i = start.x % scaledGrid; i < canvasWidth; i+= scaledGrid) {
        ctx.moveTo(i, 0);
        ctx.lineTo(i, canvasHeight);
      }
      for(i = start.y % scaledGrid; i < canvasHeight; i+= scaledGrid) {
        ctx.moveTo(0, i);
        ctx.lineTo(canvasWidth, i);
      }
      ctx.strokeStyle = "#EEEEEE";
      ctx.stroke();
    }
    //render 12inch grid
    ctx.beginPath();
    for(i = start.x; i < canvasWidth; i+=gridSize) {
      ctx.moveTo(i, 0);
      ctx.lineTo(i, canvasHeight);
    }
    for(i = start.y; i < canvasHeight; i+= gridSize) {
      ctx.moveTo(0, i);
      ctx.lineTo(canvasWidth, i);
    }
    ctx.strokeStyle = '#DDDDDD';
    ctx.stroke();
    //render center lines
    ctx.beginPath();
    ctx.moveTo(center.x, 0);
    ctx.lineTo(center.x, canvasHeight);
    ctx.moveTo(0, center.y);
    ctx.lineTo(canvasWidth, center.y);
    ctx.strokeStyle = '#BBBBBB';
    ctx.stroke();
  };
};

export default new workspace
